import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=e77d406c&scoped=true&"
import script from "./PageLoading.vue?vue&type=script&lang=js&"
export * from "./PageLoading.vue?vue&type=script&lang=js&"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=e77d406c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e77d406c",
  null
  
)

export default component.exports